import { Component, OnInit, Inject } from "@angular/core";
import { ImagenService } from "src/app/servicios/imagen.service";
import { DomSanitizer } from "@angular/platform-browser";

import { jsPDF } from "jspdf";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-dialog-documento",
  templateUrl: "./dialog-documento.component.html",
  styleUrls: ["./dialog-documento.component.css"],
})
export class DialogDocumentoComponent implements OnInit {
  imagenes: any[] = [];
  imagenesBase64: any[] = [];
  loading = false;
  ordenSAP: any;
  idServicio: any;
  tipoImagen: any;
  dataModified = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialogRef: MatDialog,
    private servicioImagen: ImagenService,
    private sanitizer: DomSanitizer
  ) {
    this.ordenSAP = dataDialog.ordenSAP;
    this.idServicio = dataDialog.idServicio;
    this.tipoImagen = dataDialog.tipoImagen;

    this.loading = true;
    this.servicioImagen
      .getImagenes(this.idServicio, this.tipoImagen)
      .subscribe((result) => {
        result.forEach((element) => {
          this.loading = false;
          this.imagenes.push(
            this.sanitizer.bypassSecurityTrustUrl(
              "data:image/png;base64," + element.imagen
            )
          );
          this.imagenesBase64.push(element.imagen);
        });
      });
  }

  ngOnInit() {}

  crearPDF() {
    let doc = new jsPDF("p", "mm", "letter");
    let label = "";
    if (this.tipoImagen == 1) {
      label = "-Fotos";
    } else if (this.tipoImagen == 2) {
      label = "-Firma";
    } else if (this.tipoImagen == 3) {
      label = "-Documentos";
    }

    const width = doc.internal.pageSize.getWidth();
    const height = doc.internal.pageSize.getHeight();

    let i = 0;
    this.imagenesBase64.forEach((element) => {
      doc.addImage(element, "PNG", 0, 0, width, height);
      i++;
      if (this.imagenesBase64.length > 1 && i < this.imagenesBase64.length) {
        doc.addPage();
      }
    });

    doc.save(this.ordenSAP + label + ".pdf");
  }
}
